(function(){
  function ready(fn){
    if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);}
  }

  function ensureStyles(){
    if(document.getElementById('stock-badge-styles')) return;
    const s=document.createElement('style'); s.id='stock-badge-styles';
  s.textContent = `
  .t4s-product__stock .stock-badge{
    display:inline-block;
    padding:var(--badge-padding-y,4px) var(--badge-padding-x,8px) !important;
    margin-top:var(--badge-margin-top,6px) !important;
    border-radius:0.5rem;
    font-size:var(--badge-font-size,16px) !important;
    line-height:1.25;
    border:1px solid transparent;
    font-weight:400 !important;
  }
  .t4s-product__stock .stock-badge--in{background:#eef8ee;border-color:#bfe3bf;}
  .t4s-product__stock .stock-badge--low{background:#fff6e5;border-color:#ffd9a8;}
  .t4s-product__stock .stock-badge--out{background:#fdecec;border-color:#f5b5b5;}
  .t4s-product__stock .stock-badge--pre{background:#eef3ff;border-color:#c7d6ff;}
`;

    document.head.appendChild(s);
  }

  // ---------- helpers ----------
  function normalizeVariants(jsonText){
    try{
      const parsed = JSON.parse(jsonText);
      if (Array.isArray(parsed)) return parsed;                      // Unsen: .pr_variants_json = [...]
      if (parsed && Array.isArray(parsed.variants)) return parsed.variants; // fallback
    }catch(e){}
    return null;
  }

  function findVariantById(variants, id){
    if(!variants) return null;
    const needle = String(id || '');
    for (let i=0;i<variants.length;i++){
      if (String(variants[i].id) === needle) return variants[i];
    }
    return null;
  }

  function getUrlVariant(){
    try{ return (new URLSearchParams(location.search)).get('variant'); }catch(e){ return null; }
  }

  function getSelectedOptions(sectionRoot){
    const vals = [];
    for (let i=1;i<=3;i++){
      const sel = sectionRoot.querySelector(`[name="option${i}"]`);
      if (sel) {
        if (sel.tagName === 'SELECT') vals.push(sel.value);
        else {
          const checked = sectionRoot.querySelector(`[name="option${i}"]:checked`);
          if (checked) vals.push(checked.value);
        }
      }
    }
    const optionsArr = sectionRoot.querySelectorAll('select[name="options[]"], [name="options[]"]:checked');
    if (optionsArr && optionsArr.length){
      const tmp = [];
      optionsArr.forEach(el=>{
        if (el.tagName==='SELECT') tmp.push(el.value);
        else if (el.checked) tmp.push(el.value);
      });
      if (tmp.length) return tmp;
    }
    return vals;
  }

  function findVariantByOptions(variants, selectedOptions){
    if (!variants || !selectedOptions || !selectedOptions.length) return null;
    const want = selectedOptions.map(v => String(v||'').trim());
    return variants.find(v=>{
      const opts = (v.options || []).map(x => String(x||'').trim());
      if (opts.length < want.length) return false;
      for (let i=0;i<want.length;i++){
        if (opts[i] !== want[i]) return false;
      }
      return true;
    }) || null;
  }

  // Qty cache + inflight fetch (per variantId)
  const qtyCache = new Map();
  const inflight = new Map();

  async function fetchVariantQty(variantId){
    const key = String(variantId);
    if (qtyCache.has(key)) return qtyCache.get(key);
    if (inflight.has(key)) return inflight.get(key);
    const p = (async () => {
      try{
        const res = await fetch(`/variants/${key}.json`, { credentials: 'same-origin' });
        if(!res.ok) throw new Error('Bad status');
        const data = await res.json();
        const q = (data && data.variant && typeof data.variant.inventory_quantity === 'number')
          ? data.variant.inventory_quantity
          : null;
        qtyCache.set(key, q);
        return q;
      }catch(e){
        qtyCache.set(key, null);
        return null;
      }finally{
        inflight.delete(key);
      }
    })();
    inflight.set(key, p);
    return p;
  }

  // Label-logica
  function computeLabel({tracked, applyNoTrack, available, continues, qty, lowThreshold, L}){
    if (typeof available !== 'boolean') available = true;

    if (tracked) {
      if (available){
        if (continues && qty !== null && qty <= 0) return { text: L.pre,  badge: 'pre' };
        if (qty !== null && qty <= lowThreshold)   return { text: L.low,  badge: 'low' };
        return { text: L.in, badge: 'in' };
      } else {
        if (continues) return { text: L.pre, badge: 'pre' };
        return { text: L.out, badge: 'out' };
      }
    } else if (applyNoTrack) {
      if (!available) {
        if (continues) return { text: L.pre, badge: 'pre' };
        return { text: L.out, badge: 'out' };
      }
      if (qty === null || qty <= 0) return { text: L.in, badge: 'in' };
      if (qty <= lowThreshold)      return { text: L.low, badge: 'low' };
      return { text: L.in, badge: 'in' };
    } else {
      if (!available) {
        if (continues) return { text: L.pre, badge: 'pre' };
        return { text: L.out, badge: 'out' };
      }
      return { text: L.in, badge: 'in' };
    }
  }

  function getCurrentVariantId(sectionRoot, variants, el){
    const idInput = sectionRoot.querySelector('form[action*="/cart/add"] [name="id"], [name="id"]');
    if (idInput && idInput.value) return String(idInput.value);
    const urlVar = getUrlVariant();
    if (urlVar) return String(urlVar);
    const opts = getSelectedOptions(sectionRoot);
    const v = findVariantByOptions(variants, opts);
    if (v) return String(v.id);
    const avail = variants.find(x => !!x.available);
    return String((avail || variants[0] || {}).id || '');
  }

  // ---------- per badge ----------
  function setupBadge(el){
    if (el.dataset.vstockInit === '1') return;
    el.dataset.vstockInit = '1';

    const sid = el.dataset.sectionId;
    const sectionRoot =
      document.getElementById('shopify-section-' + sid) ||
      el.closest('#shopify-section-' + sid) ||
      el.closest('[id^="shopify-section"]') || document;

    const variantsScript =
      sectionRoot.querySelector('script.pr_variants_json[type="application/json"]') ||
      sectionRoot.querySelector('script[type="application/json"].pr_variants_json');
    const variants = variantsScript ? normalizeVariants(variantsScript.textContent) : null;
    if(!variants || !variants.length) return;

    const lowThreshold = parseInt(el.dataset.lowThreshold || '5', 10);
    const L = {
      in:  el.dataset.labelIn  || 'Op voorraad',
      low: el.dataset.labelLow || 'Nog weinig op voorraad',
      out: el.dataset.labelOut || 'Niet op voorraad',
      pre: el.dataset.labelPre || 'Pre-order beschikbaar'
    };
    const applyNoTrack = (String(el.dataset.applyNoTrack || '').toLowerCase() === 'true');

    let rafId = null;

    async function render(){
      const currentVid = getCurrentVariantId(sectionRoot, variants, el);
      if (!currentVid) return;
      if (rafId) cancelAnimationFrame(rafId);

      rafId = requestAnimationFrame(async () => {
        const v = findVariantById(variants, currentVid);
        if(!v) return;

        // 🔒 Maatwerk override: als data-custom-made="true", altijd groene badge met custom label
        if ((el.dataset.customMade || '').toLowerCase() === 'true') {
          const label = el.dataset.labelCustom || 'Op bestelling te produceren';
          el.className = 'stock-badge stock-badge--in';
          el.textContent = label;
          el.setAttribute('data-variant-id', currentVid);
          el.setAttribute('data-track', v.inventory_management || '');
          return;
        }

        const tracked   = !!v.inventory_management;
        const available = (typeof v.available === 'boolean') ? v.available : true;
        const continues = v.inventory_policy === 'continue';

        // server-qty alleen gebruiken als die bij deze variant hoort
        let datasetQty = null;
        if (el.dataset.variantId === currentVid && el.dataset.qty && !isNaN(parseInt(el.dataset.qty, 10))) {
          datasetQty = parseInt(el.dataset.qty, 10);
        }

        // qty prioriteit: datasetQty → JSON → cache → null
        let qty = null;
        if (datasetQty !== null) qty = datasetQty;
        else if (typeof v.inventory_quantity === 'number') qty = v.inventory_quantity;
        else if (qtyCache.has(currentVid)) qty = qtyCache.get(currentVid);

        // eerste render
        let o = computeLabel({tracked, applyNoTrack, available, continues, qty, lowThreshold, L});
        el.className = 'stock-badge stock-badge--' + o.badge;
        el.textContent = o.text;
        el.setAttribute('data-variant-id', currentVid);
        el.setAttribute('data-track', v.inventory_management || '');

        // indien drempel van toepassing is maar qty nog onbekend → fetch
        const needsQty = (tracked || applyNoTrack);
        if (needsQty && qty === null) {
          const fetchedQty = await fetchVariantQty(currentVid);
          const nowVid = getCurrentVariantId(sectionRoot, variants, el);
          if (nowVid === currentVid) {
            qtyCache.set(currentVid, fetchedQty);
            const o2 = computeLabel({tracked, applyNoTrack, available, continues, qty: fetchedQty, lowThreshold, L});
            el.className = 'stock-badge stock-badge--' + o2.badge;
            el.textContent = o2.text;
          }
        } else {
          qtyCache.set(currentVid, qty);
        }
      });
    }

    // --- listeners ---
    const form = sectionRoot.querySelector('form[action*="/cart/add"]') || sectionRoot;
    const idInput = form.querySelector('[name="id"]');
    if (idInput) {
      idInput.addEventListener('change', render);
      const moId = new MutationObserver(render);
      moId.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }
    form.querySelectorAll('select[name^="option"], select[name="options[]"], input[type="radio"][name^="option"]').forEach(elm=>{
      elm.addEventListener('change', render);
      elm.addEventListener('input', render);
    });
    ['variant:changed','variantChange','product:variant-change','theme:variant:change'].forEach(evt=>{
      sectionRoot.addEventListener(evt, render);
      document.addEventListener(evt, render);
    });
    const mo = new MutationObserver((muts)=>{
      for (const m of muts){
        if (m.type==='childList') {
          if (m.addedNodes && m.addedNodes.length) render();
          if (m.removedNodes && m.removedNodes.length) render();
        }
      }
    });
    mo.observe(sectionRoot, { childList:true, subtree:true });

    // init
    render();
  }

  function setupAll(){
    ensureStyles();
    document.querySelectorAll('[data-role="variant-stock"]').forEach(setupBadge);
  }

  const globalMo = new MutationObserver((muts)=>{
    for (const m of muts){
      if (m.type==='childList' && m.addedNodes && m.addedNodes.length){
        if (document.querySelector('[data-role="variant-stock"]:not([data-vstock-init="1"])')) {
          setupAll();
        }
      }
    }
  });
  ready(function(){
    setupAll();
    globalMo.observe(document.documentElement, { childList:true, subtree:true });
    window.addEventListener('popstate', setupAll);
  });
})();
